<div class="empty-state text-center py-5 px-3">
  <i class="fa fa-{{ icon }} empty-state__icon" aria-hidden="true"></i>
  <h5 class="empty-state__title mt-3 mb-1">{{ titleKey | translate }}</h5>
  <p class="empty-state__message text-muted mb-0">{{ messageKey | translate }}</p>

  @if (actionKey) {
    <button type="button" class="btn btn-primary mt-3">
      {{ actionKey | translate }}
    </button>
  }
</div>
